module.exports = __webpack_public_path__ + "static/media/dentist01.9d9a7cf4.jpg";